// src/app/core/interceptors/static-auth-token.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

function readToken(): string {
  // 1 meta tag
  try {
    const v = document
      .querySelector('meta[name="app-handshake"]')
      ?.getAttribute('content')
      ?.trim();
    if (v) return v;
  } catch {}

  // 2 runtime globals
  const w = window as any;
  const g =
    (w.APP_HANDSHAKE_TOKEN as string)?.trim?.() ||
    (w.__APP_HANDSHAKE_TOKEN__ as string)?.trim?.() ||
    '';
  if (g) return g;

  // 3 build-time fallback
  const e = (environment as any)?.handshakeToken;
  return typeof e === 'string' ? e.trim() : '';
}

function shouldAttach(url: string): boolean {
  const base = String((environment as any)?.apiUrl || '').trim();
  if (!base) return false;

  // attach for:
  // - absolute apiUrl calls
  // - localhost proxy calls like "/city" during dev
  const isAbsoluteApi = url.startsWith(base);
  const isLocalProxy = url.startsWith('/');

  if (!isAbsoluteApi && !isLocalProxy) return false;

  // Endpoints that must receive the static handshake token
  const protectedEndpoints = [
    '/user_verification',
    '/city',
    '/city_baseline',
    '/simulation_t0',
    '/update',
    '/summary',
    '/summary_t3',
    '/simulation',
    '/admin_user_details',
    '/admin_city_details',
    '/admin_onboard_new_user',
    '/admin_user_action'
  ];

  const endsWithAny = (path: string) => protectedEndpoints.some((p) => path.endsWith(p));

  try {
    if (isAbsoluteApi) {
      const u = new URL(url);
      return endsWithAny(u.pathname);
    }
  } catch {}

  // fallback for relative/proxy URLs
  return endsWithAny(url.split('?')[0]);
}

export const staticAuthTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (!shouldAttach(req.url)) return next(req);

  const token = readToken();
  if (!token) return next(req);

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};